<!--
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-10-14 11:12:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-16 09:56:56
 * @FilePath: /goldenSalesMobile/src/views/ShoppingList/index.vue
 * @Description: 消费者购物商品列表
-->
<template>
  <div class="order-page-container">
    <!-- goods-list -->
    <div class="tab-list f-1">
      <van-tabs
        v-model="acIdx"
        swipeable
        sticky
        color="var(--tc)"
        title-active-color="var(--tc)"
        title-inactive-color="#666666"
        @change="onTabChange"
      >
        <van-pull-refresh
          v-model="refreshing"
          @refresh="init"
          v-if="tabList.length > 0"
        >
          <van-tab
            v-for="(item, index) in tabList"
            :key="index"
            :name="item.Id"
            :title="item.Name"
            :swipe-threshold="5"
          >
            <van-list
              v-model="loading"
              :finished="finished"
              :error.sync="loadError"
              :immediate-check="false"
              :offset="30"
              error-text="请求失败，点击重新加载"
              finished-text=""
              @load="onLoad"
            >
              <orderListComp
                :datas="datas"
                @delete="deleteItem"
              ></orderListComp>
            </van-list>
          </van-tab>
        </van-pull-refresh>
        <van-empty v-if="datas.length === 0" description="您暂时没有相关订单" />
      </van-tabs>
    </div>

    <!-- <g-no-content
      v-if="datas.length === 0"
      title="您暂时没有相关订单"
      class="no-order-content f-1"
    ></g-no-content> -->

    <myFooter></myFooter>
  </div>
</template>

<script>
import { testGetAESPhone, silentLogin } from "@/api/user";
import { setToken, getToken } from "@/utils/auth";
import { getStoreBanner } from "@/api/system";
import { getUserOrderList } from "@/api/order";
import myFooter from "@/components/myFooter";
// import orderListComp from './comps/orderListComp'
import orderListComp from "@/newViews/goods/comps/orderListComp.vue";
export default {
  name: "Order",
  components: {
    orderListComp,
    myFooter,
  },
  data() {
    return {
      userInfo: {
        phone: this.$route.query.phone,
        name: this.$route.query.userName,
        headImageUrl: this.$route.query.headImageUrl,
      },
      bannerList: [],
      loading: false,
      refreshing: false,
      finished: false,
      loadError: false,
      acIdx: "",
      tabList: [
        { Name: "全部", Id: "" },
        { Name: "待付款", Id: "0" },
        { Name: "待使用", Id: "1" },
        // { Name: '待收货', Id: 4 },
        // { Name: '待评价', Id: 5 },
      ],
      pageIndex: 1,
      pageSize: 5,
      datas: [],
    };
  },

  created() {
    let parthIdx = this.$route.query.index;
    if (!parthIdx) {
      this.acIdx = "";
    } else {
      this.acIdx = parthIdx;
    }
    this.init();
  },

  methods: {
    // 初始化
    async init() {
      this.resetParams();
      // 加载产品列表前5条数据
      this.getOrderList();
    },
    deleteItem() {
      this.resetParams();
      // 加载产品列表前5条数据
      this.getOrderList();
    },
    getOrderList() {
      let sendParams = {
        query: { Status: this.acIdx },
        pager: {
          pageindex: this.pageIndex,
          pagesize: this.pageSize,
        },
      };
      getUserOrderList(sendParams)
        .then((res) => {
          let resDatas = res.Items;
          if (Array.isArray(resDatas)) {
            this.datas = this.datas.concat(resDatas);
            if (this.datas.length >= res.Pager.TotalCount) {
              this.finished = true;
            }
          }
          // debugger
          this.loading = false;
          this.refreshing = false;
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        })
        .finally(() => {
          // console.log("最后");
          // // debugger
          // this.loading = false;
          // this.refreshing = false;
        });
    },

    // 上拉加载
    onLoad() {
      this.pageIndex += 1;
      this.getOrderList();
    },

    // tab切换
    onTabChange(val) {
      this.resetParams();
      this.getOrderList();
    },

    resetParams() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 1;
      this.datas = [];
    },

    // 查看产品详情
    onCheckDetail(productId, i) {
      this.$router.push({
        name: "SaleGoodsDetail",
        params: { id: productId },
      });
      // this.$router.push({
      //   name: 'GoodsDetail',
      //   params: { id: productId }
      // })
    },
  },
};
</script>

<style lang="scss" scoped>
.order-page-container {
  position: relative;
  padding-bottom: calc(100px + env(safe-area-inset-bottom));
  min-height: calc(100vh - 100px - env(safe-area-inset-bottom));
  display: flex;
  flex-direction: column;
  .no-order-content {
    position: unset;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transform: unset;
  }
}
</style>
